module.exports = __webpack_public_path__ + "img/workforce-analytics.cdd12f94.webp";